import Echo from "laravel-echo";
import Pusher from "pusher-js";
import Cookies from "js-cookie";
import { createEchoOptions } from "@/shared/realtime/createEchoOptions.mjs";
import { createRealtimeManager } from "@/shared/realtime/createRealtimeManager.mjs";
import { createRealtimeToastNotifier } from "@/shared/realtime/createRealtimeToastNotifier.mjs";
import { showToast } from "@/utils/toastService";

window.Pusher = Pusher;

const realtimeToastNotifier = createRealtimeToastNotifier({
  notify: showToast,
  notifyApplicationEvents: true,
});

const realtimeManager = createRealtimeManager({
  createClient: (options) => new Echo(options),
  getToken: () => Cookies.get("auth_token"),
  createOptions: (token) => createEchoOptions({
    env: process.env,
    location: window.location,
    token,
  }),
  onClientCreated: (client) => {
    client?.connector?.pusher?.bind_global?.((eventName, payload) => {
      realtimeToastNotifier.onEvent(eventName, payload);
    });
  },
});

realtimeManager.subscribeState(realtimeToastNotifier.onState);

export const initializeWebSocket = () => realtimeManager.start();

export const disconnectWebSocket = () => realtimeManager.stop();

export const getEcho = () => realtimeManager.getClient();

export const getWebSocketState = () => realtimeManager.getState();

export const subscribeWebSocketState = (listener) => realtimeManager.subscribeState(listener);

export const restartWebSocketAuthentication = () => realtimeManager.restartAuthentication();
